<template>
	<span :class="{ 'text-success': value >= 0 && color, 'text-danger': value < 0 && color }">
		<template v-if="value > 0">+</template>
    <span v-if="value">{{ value | number(null) }} %</span>
    <span v-else>{{ value | number(null) }}</span>
	</span>
</template>

<script>
export default {
	name: "profit",
	props: {
		value: {
			type: Number,
            required: false,
            default: 0,
		},
		color: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
};
</script>

<style scoped></style>
